
import { Burger, Container, Group, Image, Menu, Drawer, ScrollArea, Divider } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import './Navbar.css'
import Logo from '../Images/Logogvinfotech.png';
//import Brochure from '../Assets/Ourbrochure.pdf';

const links = [
  { link: "/", label: "Home" },
  { link: "/aboutus", label: "About us" },
  // { link: "/services", label: "Services" },
  // { link: "/work-details", label: "Our Work" },
  { link: "/contactus", label: "Contact us" },
  { link: "/details-about-boom-pay", label: "BOOM Pay.in" },
  // {
  //   link: "#1",
  //   label: "Learn",
  //   links: [
  //     { link: "/docs", label: "Documentation" },
  //     { link: "/resources", label: "Resources" },
  //     { link: "/community", label: "Community" },
  //     { link: "/blog", label: "Blog" },
  //   ],
  // },
  // { link: "/about", label: "About" },
  // { link: "/pricing", label: "Pricing" },
  // {
  //   link: "#2",
  //   label: "Support",
  //   links: [
  //     { link: "/faq", label: "FAQ" },
  //     { link: "/demo", label: "Book a demo" },
  //     { link: "/forums", label: "Forums" },
  //   ],
  // },
];

const Navbar = () => {
  const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] = useDisclosure(false);
  const items = links.map((item) => {
    <Menu.Item key={item.link}>{item.label}</Menu.Item>

    // if (menuItems) {
    //   return (
    //     <Menu
    //       key={link.label}
    //       trigger="hover"
    //       transitionProps={{ exitDuration: 0 }}
    //       withinPortal
    //     >
    //       <Menu.Target>
    //         <a
    //           href={link.link}
    //           className={"nav-link"}
    //           onClick={(event) => event.preventDefault()}
    //         >
    //           <Center>
    //             <span className={"nav-linkLabel"}>{link.label}</span>
    //             {/* <IconChevronDown size={14} stroke={1.5} /> */}
    //           </Center>
    //         </a>
    //       </Menu.Target>
    //       <Menu.Dropdown>{menuItems}</Menu.Dropdown>
    //     </Menu>
    //   );
    // }

    return (
      <a
        key={item.label}
        href={item.link}
        className={"nav-link"}
      // onClick={(event) => event.preventDefault()}
      >
        {item.label}
      </a>
    );
  });
  return (
    <>
      <header className={"nav-header"}>
        <Container size="md">
          <div className={"nav-inner"}>
            <Image src={Logo} alt="GV InfoTech" w={200} h={60} radius={'md'} mt={'md'}/>
            <Group gap={5} visibleFrom="sm">
              {items}
              {/* <Button size="xs" variant="gradient" gradient={{ from: 'blue', to: 'cyan', deg: 90 }} onClick={()=> window.location.href= Brochure}>Download Brochure</Button> */}
            </Group>
            <Burger opened={drawerOpened} onClick={toggleDrawer} hiddenFrom="sm" color="white"/>
          </div>
        </Container>
      </header>
      <Drawer
        opened={drawerOpened}
        onClose={closeDrawer}
        size="100%"
        padding="md"
        title={<Group><Image src={Logo} alt="GV InfoTech" w={200} h={50} radius={'md'} /> </Group>}
        hiddenFrom="sm"
        zIndex={1000000}
      >
        <ScrollArea h="calc(100vh - 80px" mx="-md">
          <Divider my="sm" />
          <Group justify="center" pb="xl" px="md">
            {items}
            {/* <Button size="xs" variant="gradient" gradient={{ from: 'blue', to: 'cyan', deg: 90 }} onClick={()=> window.location.href= Brochure}>Download Brochure</Button> */}
          </Group>
        </ScrollArea>
      </Drawer>
    </>
  );
};

export default Navbar;
